import React from "react";

export const Footer = () => {
  return (
    <footer className="border-t border-border mt-20">
      <div className="max-w-[1280px] mx-auto px-6 md:px-8 py-10 flex flex-col md:flex-row justify-between gap-6 text-xs text-muted-foreground">
        <div className="flex items-center gap-2.5">
          <div className="h-6 w-6 flex items-center justify-center border border-[hsl(var(--gold))] rounded-sm">
            <span className="font-display font-bold text-[9px] gold-text">FT</span>
          </div>
          <span className="font-display tracking-tight text-sm text-foreground">FRONTERA INTELLIGENCE</span>
        </div>
        <div className="flex items-center gap-6">
          <a href="#pricing" className="hover:text-foreground">Pricing</a>
          <a href="#sample" className="hover:text-foreground">Sample</a>
          <a href="#who-its-for" className="hover:text-foreground">Who It's For</a>
          <a href="mailto:access@frontera.io" className="hover:text-foreground">Contact</a>
        </div>
        <div>© {new Date().getFullYear()} Frontera Intelligence. Private access.</div>
      </div>
    </footer>
  );
};
